/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DateTime } from 'luxon';

import { IShowLast } from '../../filter.interface';

@Component({
  selector: 'showlast-filter-item',
  templateUrl: './showlast-filter-item.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => {
        return ShowlastFilterItemComponent;
      }),
      multi: true,
    },
  ],
})
export class ShowlastFilterItemComponent implements ControlValueAccessor {
  @Input() filterItem: IShowLast;

  value: any;

  onChange: (value: any) => void;
  onTouched: () => void;

  writeValue(value: any) {
    this.value = value;

    this.onValueChanged();
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  onValueChanged() {
    if (this.value) {
      const pastPeriod = DateTime.now().plus({ days: -this.value }).toISO();
      const today = DateTime.now().toISO();

      const dateRange = {
        startDate: pastPeriod,
        endDate: today,
      };

      this.onChange(dateRange);
    } else {
      this.onChange(this.value);
    }
  }
}
